import React from 'react'
import styled from 'styled-components'
import Text from '../../utils/Text'
import media from '../../utils/media'

const Container = styled.div`
  text-align: center;
  margin-bottom: ${props =>
    props.marginBTitle ? props.marginBTitle : 28}px;
  ${media.mobileL`
    margin-bottom: ${props =>
      props.marginBTitle ? props.marginBTitle : 18}px;
  `}
`

const TextComponent = styled.div`
  p {
    font-family: ${props =>
      props.titleFamily ? props.titleFamily : 'Raleway'};
    color: ${props =>
      props.titleColor ? props.titleColor : '#414141'};
    font-size: ${props => (props.titleSize ? props.titleSize : 35)}px;
    line-height: ${props =>
      props.lineHeight ? props.lineHeight : 1};
    ${media.mobileL`
    font-size: calc(${props =>
      props.titleSize ? props.titleSize : 35}px - 5px);
    `}
    strong {
      display: inline-block;
      font-weight: 600 !important;
    }
  }
`

export default function Title({ ...props }) {
  const {
    title,
    titleSize,
    titleColor,
    marginBTitle,
    titleFamily,
    classN,
    lineHeight,
  } = props

  return (
    <Container
      className={`section-title ${classN}`}
      marginBTitle={marginBTitle}
    >
      <TextComponent
        titleSize={titleSize}
        titleColor={titleColor}
        titleFamily={titleFamily}
        lineHeight={lineHeight}
      >
        <Text id={title} markdown />
      </TextComponent>
    </Container>
  )
}
